import Draggable from "@/assets/vuedraggable/dist/vuedraggable.umd.js";
import * as Icons from "@ant-design/icons-vue";
import FormDesign from "@/components/form-design/index.vue";
import FormRender from "@/components/form-render/index.vue";
FormDesign.install = (Vue) => {
  Vue.component("draggable", Draggable);
  // 注册图标组件
  for (const i in Icons) {
    Vue.component(i, Icons[i]);
  }
  Vue.component(FormDesign.name, FormDesign);
};
FormRender.install = (Vue) => {
  Vue.component("draggable", Draggable);
  // 注册图标组件
  for (const i in Icons) {
    Vue.component(i, Icons[i]);
  }
  Vue.component(FormRender.name, FormRender);
};

// 存储组件列表
const components = [FormDesign, FormRender];
// 定义 install 方法，接收 Vue 作为参数。如果使用 use 注册插件，则所有的组件都将被注册
const install = function (Vue) {
  // 判断是否安装
  if (install.installed) return;

  Vue.component("draggable", Draggable);
  // 注册图标组件
  for (const i in Icons) {
    Vue.component(i, Icons[i]);
  }
  // 遍历注册全局组件
  components.forEach((component) => {
    Vue.component(component.name, component);
  });
};

// 判断是否是直接引入文件
if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}
export default {
  // 导出的对象必须具有 install，才能被 Vue.use() 方法安装
  install,
  // 以下是具体的组件列表
  FormDesign,
  FormRender,
};
